import { Hourglass } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const FormPendingReviewBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-warning text-white">
      <Hourglass />
      <span>{t('component:badge.formPendingReview')}</span>
    </Badge>
  );
};
